import React, { PureComponent } from 'react';
import GridHeader from './GridHeader';
import GridBody from './GridBody';
import './grid.scss';

// adding pure component to not refresh it after clicking on row
class RMGrid extends PureComponent {

  constructor(props) {
    super(props);
    const defaultSortConfig = this.getDefaultSortConfig(props.columns);
    const initialRows = this.addRowIndex(this.sortRows(
      props.rows,
      props.columns,
      defaultSortConfig
    ));

    // Define initial state for rows and sorting
    this.state = {
      rows: initialRows,
      sortConfig: defaultSortConfig, // Default sorting state
      groupField: this.getGroupField(props.columns),
      maxHeight: null
    };

    this.tbodyRef = null;
    this.theadRef = null;
    this.gridContainerRef = null;
    this.setGridContainerRef = element => { this.gridContainerRef = element; };
    this.setTbodyRef = element => { this.tbodyRef = element; };
    this.setTheadRef = element => { this.theadRef = element; };

    this.handleSort = this.handleSort.bind(this);
  }

  componentDidMount() {
    this.updateMaxHeight();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.rows !== this.state.rows || prevProps.expanded !== this.props.expanded) {
      this.updateMaxHeight();
    }
  }

  sortRows = (rows, columns, sortConfig) => {
    const { key, direction } = sortConfig;
    if (key === null || !direction) return rows;

    const field = columns[key].field;
    if (!field) return rows;

    return [...rows].sort((a, b) => {
      const valueA = a[field] || '';
      const valueB = b[field] || '';

      const isDateA = !isNaN(Date.parse(valueA));
      const isDateB = !isNaN(Date.parse(valueB));

      if (isDateA && isDateB) {
        const dateA = new Date(valueA);
        const dateB = new Date(valueB);
        return direction === 'ASC' ? dateA - dateB : dateB - dateA;
      }

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return direction === 'ASC'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      if (valueA < valueB) return direction === 'ASC' ? -1 : 1;
      if (valueA > valueB) return direction === 'ASC' ? 1 : -1;

      return 0;
    });
  };

  updateMaxHeight = () => {
    const { rows } = this.state;
    let headerHeight = 0;
    let rowsHeight = 0;
    let scrollSize = 0;

    if (this.theadRef) {
      headerHeight = this.theadRef.offsetHeight;
    }

    let rowsInTable = 5;
    let rowCount = rowsInTable;
    if (this.state.groupField) {
      let groups = new Set();
      rowCount = rows.length
      for (let i = 0; i < rows.length; i++) {
        let value = rows[i][this.state.groupField];
        if (value) {
          if (!groups.has(value) && groups.size < rowsInTable + 1) {
              groups.add(value);
          } 
          if (groups.size === rowsInTable + 1) {
            rowCount = i;
            break;
          }
        }
      }
    }

    if (rows && rows.length > 0 && this.tbodyRef) {
      const rowElements = Array.from(this.tbodyRef.children).slice(0, rowCount);
      rowsHeight = rowElements.reduce((sum, row) => sum + row.offsetHeight, 0);
    }

    if (this.gridContainerRef && this.gridContainerRef.scrollWidth > this.gridContainerRef.clientWidth) {
      scrollSize = 15; // Add 15px if horizontal scrollbar is present
    }

    if (rows && rows.length > rowCount) {
      this.setState({ maxHeight: headerHeight + rowsHeight + scrollSize });
    } else {
      this.setState({ maxHeight: null });
    }
  };

  addRowIndex = (rows) => {
    return rows.map((row, index) => ({ ...row, index }));
  };

  getGroupField = (columns) => {
    const groupColumn = columns.find((col) => col.groupField === true); 
    return groupColumn ? groupColumn.field : null; 
  };

  getDefaultSortConfig = (columns) => {
  for (let i = 0; i < columns.length; i++) {
    const col = columns[i];
    if (col.sortConfig && col.sortConfig.direction) {
      return { key: i, direction: col.sortConfig.direction };
    }
    if (col.defaultSort) {
      return { key: i, direction: col.defaultSort };
    }
  }
  return { key: null, direction: null };
};

  handleSort = (newSortConfig) => {
    const sortedRows = this.sortRows(
      this.state.rows,
      this.props.columns,
      newSortConfig
    );
    this.setState({ rows: sortedRows, sortConfig: newSortConfig });
  };


  render() {
    //const { columns } = this.props; // Destructure props for header and body
    const columns = this.props.columns.filter(col => col.required !== false || this.props.rows.some(row => !!row[col.field]));


    return (
      <div className="rmb-grid" ref={this.setGridContainerRef} style={
                     this.state.maxHeight
                       ? { maxHeight: this.state.maxHeight, overflowY: 'auto' }
                       : { overflowY: 'visible' }
                   }>
        <table className="grid-table">
          <GridHeader columns={columns} sortConfig={this.state.sortConfig} onSort={this.handleSort} theadRef={this.setTheadRef}/>
          <GridBody {...this.props} rows={this.state.rows} columns={columns} groupField={this.state.groupField} tbodyRef={this.setTbodyRef}/>
        </table>
      </div>
    );
  }
}

RMGrid.defaultProps = {
  rows: [],
  columns: [],
};

export default RMGrid;


// WEBPACK FOOTER //
// ./src/common/core/grid/RMGrid.jsx